import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ProjectAPIs from "../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import ApiResponseHandler from "../../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { Form, Col, Row } from "react-bootstrap";
import { FaSave } from "react-icons/fa";
import { AiFillEdit } from "react-icons/ai";
import { MdCancel, MdDelete, MdEdit } from "react-icons/md";
import DropDown from "../../../../../DropDown/DropDown";
import './ViewProjectAddress.css'
import LookupAPIs from "../../../../../../MasonyFixingsAPIs/LookupAPIs/LookupAPIs";
import { useToast } from "../../../../../../Contexts/ToastContext";
import ProjectsMap from "../../../ProjectsMap/ProjectsMap";

export default function ViewProjectAddress(){


    const { addToast } = useToast();
    const params = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [sending, setSending] = useState(false);

    const [addressData, setAddressData] = useState();
    const [line1, setLine1] = useState('');
    const [line2, setLine2] = useState('');
    const [city, setCity] = useState('');
    const [countyID, setCountyID] = useState('');
    const [countryID, setCountryID] = useState('');
    const [lat, setLat] = useState(null);
    const [lng, setLng] = useState(null);

    const [counties, setCounties] = useState([]);
    const [countries, setCountries] = useState([]);

    const normalize = (str) =>
    str?.toLowerCase().replace("county ", "").trim();

    const handleReverseGeocode = (formattedData) => {
        setLat(formattedData.latitude)
        setLng(formattedData.longitude)
        if(formattedData.line1 !== ""){
            setLine1(formattedData.line1)
            setLine2('')
        }
        
        if(formattedData.city !== ""){ 
            setCity(formattedData.city)
        };

        if(formattedData.county !== ""){
            const countyName = normalize(formattedData.county);
            const matchedCounty = counties.find(
                (c) => normalize(c.county) === countyName
            );
            setCountyID(matchedCounty?.id ?? '');
            console.log('matchedCounty');
            console.log(matchedCounty);
        }
        if(formattedData.country !== ""){
            const countryName = normalize(formattedData.country);
            const matchedCountry = countries.find(
                (c) => normalize(c.country) === countryName
            );
            setCountryID(matchedCountry?.id ?? '');
            console.log('matchedCountry');
            console.log(matchedCountry);
        }
        
    }
    

    const getProjectAddress = (projectID) => {
        ProjectAPIs.GetProjectAddress(projectID)
        .then((response) => {
            if(response.status === 200){
                setAddressData(response.data);
                setLine1(response.data.line1);
                setLine2(response.data.line2 ?? '');
                setCity(response.data.city ?? '');
                setCountyID(response.data.county_id);
                setCountryID(response.data.country_id); 
                setLat(response.data.latitude)
                setLng(response.data.longitude)
                setLoading(false);
            }
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }


    const editProjectAddress = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Submitting address');
        setSending(true);

        const putJSON = {
            line1: line1,
            line2: line2,
            city: city,
            county_id: countyID,
            country_id: countryID,
            latitude: lat === '' ? null : lat,
            longitude: lng === '' ? null : lng
        }

        ProjectAPIs.PutProjectAddress(addressData.id, putJSON)
        .then((response) => {
            if(response.status === 200){
                setEditing(false);
                setSending(false);
                addToast({ message: "Address updated successfully!", variant: "success", autoHide: true });
                getProjectAddress(params.ProjectID);
            }
        })
        .catch((err) =>{
            setSending(false);
            ApiResponseHandler(err.response, navigate);
        })
    }

    const handleCancel = () => {
        setLine1(addressData.line1);
        setLine2(addressData.line2 ?? '');
        setCity(addressData.city ?? '');
        setCountyID(addressData.county_id);
        setCountryID(addressData.country_id);
        setLat(addressData.latitude ?? '');
        setLng(addressData.longitude ?? '');
        setEditing(false);
    }

    const getCounties = () => {
        LookupAPIs.GetCounties()
        .then((response) => {
            setCounties(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    const getCountries = () => {
        LookupAPIs.GetCountries()
        .then((response) => {
            setCountries(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    useEffect(() => {
        getCounties();
        getCountries();
    }, [])

    useEffect(() => {
        getProjectAddress(params.ProjectID);
    }, [params.ProjectID])

    if(loading){
        return(
            <div>Loading Address...</div>
        )
    }

    
        return(
            <div>
            <div className="project-section">

                <Form onSubmit={editProjectAddress}>

                {/* HEADER ACTIONS */}
                <div className="project-section-header">
                    {/* <h5 className="section-title">Project Address</h5> */}
                    <div className="project-header-actions">
                        <button
                            disabled={sending || !editing}
                            type="submit"
                            className="save-btn"
                            style={editing ? {display: 'block'} : {display: 'none'}}
                        >
                            {sending ? 'Saving...' : 'Save'}
                        </button>

                        {editing ? (
                            <button
                                disabled={sending}
                                type="button"
                                className="cancel-btn"
                                onClick={handleCancel}
                            >
                                Cancel
                            </button>
                        ) : (
                            <button
                                disabled={sending}
                                type="button"
                                className="edit-btn"
                                onClick={() => setEditing(true)}
                            >
                                <MdEdit /> Edit
                            </button>
                        )}
                    </div>
                </div>

                
                <div className="project-section-body">


                    {editing ? 
                            <div className="project-section-body-item">
                                <span className="label">Line 1:</span>
                                <Form.Control
                                    required
                                    disabled={!editing}
                                    value={line1}
                                    onChange={(e) => setLine1(e.target.value)}
                                    className="editable-field"
                                />
                            </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">Line 1:</span>
                                <span>{addressData.line1}</span>
                        </div>
                
                    }

                    {editing ? 
                            <div className="project-section-body-item">
                                <span className="label">Line 2:</span>
                                <Form.Control
                                    disabled={!editing}
                                    value={line2}
                                    onChange={(e) => setLine2(e.target.value)}
                                    className="editable-field"
                                />
                            </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">Line 2:</span>
                                <span>{addressData.line2}</span>
                        </div>
                
                    }

                    {editing ? 
                            <div className="project-section-body-item">
                                <span className="label">City:</span>
                                <Form.Control
                                    disabled={!editing}
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                    className="editable-field"
                                />
                            </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">City:</span>
                                <span>{addressData.city}</span>
                        </div>
                
                    }
                    



                    {editing ? 
                             <div className="project-section-body-item">
                                <span className="label">County:</span>
                                <DropDown.County
                                    required
                                    disabled={!editing}
                                    value={countyID}
                                    className="editable-field"
                                    onChange={(e) => setCountyID(e.target.value)}
                                />
                            </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">County:</span>
                                <span>{counties.find((c) => c.id == addressData.county_id)?.county ?? ''}</span>
                        </div>
                
                    }


                    {editing ? 
                            <div className="project-section-body-item">
                                <span className="label">Country:</span>
                                <DropDown.Country
                                    required
                                    disabled={!editing}
                                    value={countryID}
                                    className="editable-field"
                                    onChange={(e) => setCountryID(e.target.value)}
                                />
                            </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">Country:</span>
                                <span>{countries.find((c) => c.id == addressData.country_id)?.country ?? ''}</span>
                        </div>
                
                    }
                </div>



                </Form>
            </div>
            <div className="map-container">
                <ProjectsMap mode={editing ? "edit" : 'view'} projectId={params.ProjectID} handleReverseGeocode={handleReverseGeocode} projectAddress={addressData} />
            </div>
        </div>
        )
    
}